import React, { useEffect, useRef, useState } from "react";
import Banner from "../components/Banner";
import WhyBid from "../components/WhyBid";
import Faq from "../components/Faq";
import Footer from "../components/Footer";
import About from "../components/About";
import How from "../components/How";

function Home() {
  const [navBg, setNavBg] = useState(false);
  const changeNavBg = () => {
    window.scrollY >= 230 ? setNavBg(true) : setNavBg(false);
  };

  useEffect(() => {
    window.addEventListener("scroll", changeNavBg);
    return () => {
      window.removeEventListener("scroll", changeNavBg);
    };
  }, []);
  const catRef = useRef();

  return (
    <>

      <Banner btnRef={catRef} />

      <WhyBid />
      <How />

      <About />
      <Faq />
      <Footer />
    </>
  );
}

export default Home;
